export const PSCLocationBody = <T extends { location: string, country: string }>(item: T) => {
    return (
        <div className="justify-content-start">
            <div>
                <p>{item.location}</p>
                <small>{item.country}</small>
            </div>
        </div>
    );
}